import { AdcashGuruCoviMetrics } from '../../../../types/adcash.types';
import GuruPage from '../../../../components/adcash/guru/GuruPage';
import AdcashGuruDashboard from '../../../../components/adcash/guru/AdcashGuruDashboard';
import AdcashGuruCoviMetricsTable from '../../../../components/adcash/guru/table/AdcashGuruCoviMetricsTable';

const INITIAL: AdcashGuruCoviMetrics = {
  prevTotalRevenue: 0, prevTotalReq: 0, prevTotalImp: 0, prevTotalClk: 0,
  totalRevenue: 0, totalReq: 0, totalImp: 0, totalClk: 0,
  dailyStats: [],
};

export default function GuruCovi() {
  return (
    <GuruPage
      apiSlug="covi"
      initialMetrics={INITIAL}
      renderDashboard={(data) => <AdcashGuruDashboard dailyStats={data.dailyStats} />}
      renderTable={(data) => <AdcashGuruCoviMetricsTable data={data} />}
      tableWidth="1200px"
    />
  );
}
